<template>
  <div id="app">
    <router-view v-cloak/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  [v-cloak] {
    display: none;
  }
</style>
